/**
 * Users allowed to see the screening sheet.
 * Add/remove emails here to control rollout.
 */
export const SCREENING_SHEET_ALLOWED_EMAILS: Set<string> = new Set([
  // Add allowed user emails here during rollout
  // 'operator1@example.com',
  // 'operator2@example.com',
  'xipu@finchlegal.com',
  'viraj@finchlegal.com',
  'cole@finchlegal.com',
  'ben@finchlegal.com',
  'stacey@finchlegal.com',
  'alex.torres@finchlegal.com',
  'aysha@finchlegal.com',
  'diana.ruiz@finchlegal.com',
  'brandy@finchlegal.com',
  'jessica.torres@finchlegal.com',
  'camille@finchlegal.com',
  'diego@finchlegal.com',
  'elizabethf@finchlegal.com',
  'denise@finchlegal.com',
  'denice@finchlegal.com',
  'diana.rico@finchlegal.com',
  'deanna@finchlegal.com',
  'mitzy@finchlegal.com',
]);

/**
 * Check if user has access to screening sheet feature.
 */
export const isScreeningSheetEnabled = (
  userEmail: string | undefined,
): boolean => {
  return true;
};
